/* eslint-disable max-lines-per-function */
import React from 'react';
import { Table } from 'semantic-ui-react';
import range from 'lodash/range';
import {
    Header, Cell, renderPrice, EmptyCell, createDualColHeaders, Title
} from '../components';
import usePrint from '+/hooks/usePrint';
import Dimmer from '+/Dimmer';
import { PrintDate } from '../../../shared/components/PrintDate';

const styles = {
    root: {
        padding: '15px',
        fontWeight: 'bold'
    }
};

const MiamiRiverMatrix = props => {

    const { data, isLoading, matrixType } = props;

    const { ref, Trigger } = usePrint();

    if (!data || isLoading) return <Dimmer message='Fetching matrix, this can take up to 60 seconds' />;

    return (
        <div ref={ref} style={styles.root} className='print landscape'>
            <div>
                <Trigger />
            </div>
            <Title title='Miami River' />
            <PrintDate isForPDF={false}/>
            <Table celled compact>
                <Table.Header>
                    <Table.Row>
                        <Header colSpan='100' content='East View' />
                    </Table.Row>
                    <Table.Row>{createDualColHeaders(['A4', 'A', 'A', 'A', 'A', 'A', 'C', 'A', 'A', 'B6'])}</Table.Row>
                    <Table.Row>
                        {createDualColHeaders([
                            '2 Bedroom',
                            '2 Bedroom',
                            '2 Bedroom',
                            '2 Bedroom',
                            '2 Bedroom',
                            '2 Bedroom',
                            '1 Bedroom',
                            '2 Bedroom',
                            '2 Bedroom',
                            '3 Bedroom'
                        ])}
                    </Table.Row>
                    <Table.Row>
                        {createDualColHeaders([
                            '865 sq ft',
                            '835 sq ft',
                            '835 sq ft',
                            '835 sq ft',
                            '835 sq ft',
                            '835 sq ft',
                            '500 sq ft',
                            '835 sq ft',
                            '835 sq ft',
                            '1170 sq ft'
                        ])}
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {/* 8th and 7th floor */}
                    {range(8, 6, -1)
                        .map(n => n.toLocaleString('en-US', {
                            minimumIntegerDigits: 2,
                            useGrouping: false
                        }))
                        .map(floor => (
                            <Table.Row key={floor}>
                                {['46', '44', '42', '40', '38', '36', '34', '32', '30', '28'].map(unit => (
                                    <Cell
                                        unit={`${floor}${unit}`}
                                        price={renderPrice(data[`01-${floor}${unit}`], matrixType)}
                                        status={data[`01-${floor}${unit}`].status}
                                    />
                                ))}
                            </Table.Row>
                        ))}

                    {/* 6th thru 3rd floor */}

                    {range(6, 2, -1)
                        .map(n => n.toLocaleString('en-US', {
                            minimumIntegerDigits: 2,
                            useGrouping: false
                        }))
                        .map(floor => (
                            <Table.Row key={floor}>
                                {['46', '44', '42', '40', '38', '36', '34'].map(unit => (
                                    <Cell
                                        unit={`${floor}${unit}`}
                                        price={renderPrice(data[`01-${floor}${unit}`], matrixType)}
                                        status={data[`01-${floor}${unit}`].status}
                                    />
                                ))}
                            </Table.Row>
                        ))}

                    <Table.Row>
                        <Cell unit='0246' price={renderPrice(data['01-0246'], matrixType)} status={data['01-0246'].status} />
                        <Cell unit='0244' price={renderPrice(data['01-0244'], matrixType)} status={data['01-0244'].status} />
                        <Cell unit='0242' price={renderPrice(data['01-0242'], matrixType)} status={data['01-0242'].status} />
                        <Cell unit='0240' price={renderPrice(data['01-0240'], matrixType)} status={data['01-0240'].status} />
                        <Cell unit='0238' price={renderPrice(data['01-0238'], matrixType)} status={data['01-0238'].status} />
                        <Cell unit='0236 - (AB)' price={renderPrice(data['01-0236'], matrixType)} status={data['01-0236'].status} />
                        <Cell unit='0234' price={renderPrice(data['01-0234'], matrixType)} status={data['01-0234'].status} />
                    </Table.Row>
                    <Table.Row>
                        <Cell unit='0146' price={renderPrice(data['01-0146'], matrixType)} status={data['01-0146'].status} />
                        <Cell unit='0144' price={renderPrice(data['01-0144'], matrixType)} status={data['01-0144'].status} />
                        <Cell unit='0142' price={renderPrice(data['01-0142'], matrixType)} status={data['01-0142'].status} />
                        <Cell unit='0140' price={renderPrice(data['01-0140'], matrixType)} status={data['01-0140'].status} />
                        <Cell unit='0138' price={renderPrice(data['01-0138'], matrixType)} status={data['01-0138'].status} />
                        <Cell unit='0138' price={renderPrice(data['01-0136'], matrixType)} status={data['01-0136'].status} />
                        <Cell unit='0134' price={renderPrice(data['01-0134'], matrixType)} status={data['01-0134'].status} />
                    </Table.Row>
                </Table.Body>
            </Table>

            <Table celled compact>
                <Table.Header>
                    <Table.Row>
                        <Header colSpan='100' content='East Courtyard - View looking West' />
                    </Table.Row>
                    <Table.Row>{createDualColHeaders(['A4', 'A5', 'A', 'A', 'A', 'C2', 'A9', 'A', 'A10'])}</Table.Row>
                    <Table.Row>
                        {createDualColHeaders([
                            '2 Bedroom',
                            '2 Bedroom',
                            '2 Bedroom',
                            '2 Bedroom',
                            '2 Bedroom',
                            '1 Bedroom',
                            '2 Bedroom',
                            '2 Bedroom',
                            '2 Bedroom'
                        ])}
                    </Table.Row>
                    <Table.Row>
                        {createDualColHeaders([
                            '865 sq ft',
                            '955 sq ft',
                            '835 sq ft',
                            '835 sq ft',
                            '835 sq ft',
                            '765 sq ft',
                            '970 sq ft',
                            '835 sq ft',
                            '970 sq ft'
                        ])}
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {/* 8th and 7th floor */}
                    {range(8, 6, -1)
                        .map(n => n.toLocaleString('en-US', {
                            minimumIntegerDigits: 2,
                            useGrouping: false
                        }))
                        .map(floor => (
                            <Table.Row key={floor}>
                                {['45', '43', '41', '39', '37', '35', '33', '31', '29'].map(unit => (
                                    <Cell
                                        unit={`${floor}${unit}`}
                                        price={renderPrice(data[`01-${floor}${unit}`], matrixType)}
                                        status={data[`01-${floor}${unit}`].status}
                                    />
                                ))}
                            </Table.Row>
                        ))}

                    {/* 6th thru 3rd floor */}

                    {range(6, 1, -1)
                        .map(n => n.toLocaleString('en-US', {
                            minimumIntegerDigits: 2,
                            useGrouping: false
                        }))
                        .map(floor => (
                            <Table.Row key={floor}>
                                {['45', '43', '41', '39', '37', '35'].map(unit => (
                                    <Cell
                                        unit={`${floor}${unit}`}
                                        price={renderPrice(data[`01-${floor}${unit}`], matrixType)}
                                        status={data[`01-${floor}${unit}`].status}
                                    />
                                ))}
                            </Table.Row>
                        ))}

                    <Table.Row>
                        <Cell unit='0145' price={renderPrice(data['01-0145'], matrixType)} status={data['01-0145'].status} />
                        <Header colSpan='2' content='A2 - 895 sq ft' />
                        <Cell unit='0141' price={renderPrice(data['01-0141'], matrixType)} status={data['01-0141'].status} />
                        <Cell unit='0139' price={renderPrice(data['01-0139'], matrixType)} status={data['01-0139'].status} />
                        <Cell unit='0137' price={renderPrice(data['01-0137'], matrixType)} status={data['01-0137'].status} />
                    </Table.Row>
                    <Table.Row>
                        <EmptyCell />
                        <Cell unit='0243' price={renderPrice(data['01-0243'], matrixType)} status={data['01-0243'].status} />
                    </Table.Row>
                    <Table.Row>
                        <EmptyCell />
                        <Cell unit='0143' price={renderPrice(data['01-0143'], matrixType)} status={data['01-0143'].status} />
                    </Table.Row>
                </Table.Body>
            </Table>

            <div className='pagebreak' />
            <div className='printspace' />
            <Title title='Miami River' />
            <PrintDate isForPDF={false}/>
            <Table celled compact>
                <Table.Header>
                    <Table.Row>
                        <Header colSpan='100' content='West Courtyard - View looking East' />
                    </Table.Row>
                    <Table.Row>{createDualColHeaders(['B1', 'A', 'A', 'A', 'A', 'A', 'C1', 'A3', 'A', 'B5'])}</Table.Row>
                    <Table.Row>
                        {createDualColHeaders([
                            '3 Bedroom',
                            '2 Bedroom',
                            '2 Bedroom',
                            '2 Bedroom',
                            '2 Bedroom',
                            '2 Bedroom',
                            '1 Bedroom',
                            '2 Bedroom',
                            '2 Bedroom',
                            '3 Bedroom'
                        ])}
                    </Table.Row>
                    <Table.Row>
                        {createDualColHeaders([
                            '1125 sq ft',
                            '835 sq ft',
                            '835 sq ft',
                            '835 sq ft',
                            '835 sq ft',
                            '835 sq ft',
                            '715 sq ft',
                            '865 sq ft',
                            '835 sq ft',
                            '1195 sq ft'
                        ])}
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {/* 8th and 7th floor */}
                    {range(8, 6, -1)
                        .map(n => n.toLocaleString('en-US', {
                            minimumIntegerDigits: 2,
                            useGrouping: false
                        }))
                        .map(floor => (
                            <Table.Row key={floor}>
                                {['02', '04', '06', '08', '10', '12', '15', '16', '18', '20'].map(unit => (
                                    <Cell
                                        unit={`${floor}${unit}`}
                                        price={renderPrice(data[`01-${floor}${unit}`], matrixType)}
                                        status={data[`01-${floor}${unit}`].status}
                                    />
                                ))}
                            </Table.Row>
                        ))}

                    {/* 6th thru 3rd floor */}

                    {range(6, 2, -1)
                        .map(n => n.toLocaleString('en-US', {
                            minimumIntegerDigits: 2,
                            useGrouping: false
                        }))
                        .map(floor => (
                            <Table.Row key={floor}>
                                {['02', '04', '06', '08', '10', '12', '15'].map(unit => (
                                    <Cell
                                        unit={`${floor}${unit}`}
                                        price={renderPrice(data[`01-${floor}${unit}`], matrixType)}
                                        status={data[`01-${floor}${unit}`].status}
                                    />
                                ))}
                            </Table.Row>
                        ))}

                    <Table.Row>
                        {['02', '04', '06', '08', '10', '12'].map(unit => (
                            <Cell unit={`02${unit}`} price={renderPrice(data[`01-02${unit}`], matrixType)} status={data[`01-02${unit}`].status} />
                        ))}
                    </Table.Row>
                    <Table.Row>
                        {['02', '04', '06', '08', '10', '12'].map(unit => (
                            <Cell unit={`01${unit}`} price={renderPrice(data[`01-01${unit}`], matrixType)} status={data[`01-01${unit}`].status} />
                        ))}
                        <Header colSpan='2' content='CB' />
                    </Table.Row>
                    <Table.Row>
                        <EmptyCell count={6} />
                        <Cell unit={'0215'} price={renderPrice(data['01-0215'], matrixType)} status={data['01-0215'].status} />
                    </Table.Row>
                </Table.Body>
            </Table>

            <Table celled compact>
                <Table.Header>
                    <Table.Row>
                        <Header colSpan='100' content='West View' />
                    </Table.Row>
                    <Table.Row>{createDualColHeaders(['B2', 'A1', 'A', 'A', 'A', 'A', 'A', 'A', 'A', 'B4'])}</Table.Row>
                    <Table.Row>
                        {createDualColHeaders([
                            '3 Bedroom',
                            '2 Bedroom',
                            '2 Bedroom',
                            '2 Bedroom',
                            '2 Bedroom',
                            '2 Bedroom',
                            '2 Bedroom',
                            '2 Bedroom',
                            '2 Bedroom',
                            '3 Bedroom'
                        ])}
                    </Table.Row>
                    <Table.Row>
                        {createDualColHeaders([
                            '1280 sq ft',
                            '905 sq ft',
                            '835 sq ft',
                            '835 sq ft',
                            '835 sq ft',
                            '835 sq ft',
                            '835 sq ft',
                            '865 sq ft',
                            '835 sq ft',
                            '1190 sq ft'
                        ])}
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {/* 8th and 7th floor */}
                    {range(8, 6, -1)
                        .map(n => n.toLocaleString('en-US', {
                            minimumIntegerDigits: 2,
                            useGrouping: false
                        }))
                        .map(floor => (
                            <Table.Row key={floor}>
                                {['01', '03', '05', '07', '09', '11', '14', '17', '19', '21'].map(unit => (
                                    <Cell
                                        unit={`${floor}${unit}`}
                                        price={renderPrice(data[`01-${floor}${unit}`], matrixType)}
                                        status={data[`01-${floor}${unit}`].status}
                                    />
                                ))}
                            </Table.Row>
                        ))}

                    {/* 6th thru 3rd floor */}

                    {range(6, 2, -1)
                        .map(n => n.toLocaleString('en-US', {
                            minimumIntegerDigits: 2,
                            useGrouping: false
                        }))
                        .map(floor => (
                            <Table.Row key={floor}>
                                {['01', '03', '05', '07', '09', '11', '14'].map(unit => (
                                    <Cell
                                        unit={`${floor}${unit}`}
                                        price={renderPrice(data[`01-${floor}${unit}`], matrixType)}
                                        status={data[`01-${floor}${unit}`].status}
                                    />
                                ))}
                            </Table.Row>
                        ))}

                    <Table.Row>
                        <Header colSpan='2' content='B3' />
                        <Header colSpan='2' content='A2' />
                        {['05', '07', '09', '11', '14'].map(unit => (
                            <Cell unit={`02${unit}`} price={renderPrice(data[`01-02${unit}`], matrixType)} status={data[`01-02${unit}`].status} />
                        ))}
                    </Table.Row>

                    <Table.Row>
                        <Header colSpan='2' content='1235 sq ft' />
                        <Header colSpan='2' content='895 sq ft' />
                        {['05', '07', '09', '11', '14'].map(unit => (
                            <Cell unit={`01${unit}`} price={renderPrice(data[`01-01${unit}`], matrixType)} status={data[`01-01${unit}`].status} />
                        ))}
                    </Table.Row>

                    <Table.Row>
                        <Cell unit={'0201'} price={renderPrice(data['01-0201'], matrixType)} status={data['01-0201'].status} />
                        <Cell unit={'0203'} price={renderPrice(data['01-0203'], matrixType)} status={data['01-0203'].status} />
                    </Table.Row>
                    <Table.Row>
                        <Cell unit={'0101'} price={renderPrice(data['01-0101'], matrixType)} status={data['01-0101'].status} />
                        <Cell unit={'0103'} price={renderPrice(data['01-0103'], matrixType)} status={data['01-0103'].status} />
                    </Table.Row>
                </Table.Body>
            </Table>

            <div className='pagebreak' />
            <div className='printspace' />
            <Title title='Miami River' />
            <PrintDate isForPDF={false}/>
            <Table celled compact>
                <Table.Header>
                    <Table.Row>
                        <Header colSpan='100' content='Miami River' />
                    </Table.Row>
                    <Table.Row>
                        <Header colSpan='100' content='West View' />
                    </Table.Row>
                    <Table.Row>{createDualColHeaders(['B7', 'A6', 'A6', 'A6', 'A6', 'A8'])}</Table.Row>
                    <Table.Row>
                        {createDualColHeaders(['3 Bedroom', '2 Bedroom', '2 Bedroom', '2 Bedroom', '2 Bedroom', '2 Bedroom'])}
                    </Table.Row>
                    <Table.Row>
                        {createDualColHeaders(['1410 sq ft', '995 sq ft', '995 sq ft', '995 sq ft', '995 sq ft', '1270 sq ft'])}
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {/* 8th and 7th floor */}
                    {range(8, 6, -1)
                        .map(n => n.toLocaleString('en-US', {
                            minimumIntegerDigits: 2,
                            useGrouping: false
                        }))
                        .map(floor => (
                            <Table.Row key={floor}>
                                {['22', '23', '24', '25', '26', '27'].map(unit => (
                                    <Cell
                                        unit={`${floor}${unit}`}
                                        price={renderPrice(data[`01-${floor}${unit}`], matrixType)}
                                        status={data[`01-${floor}${unit}`].status}
                                    />
                                ))}
                            </Table.Row>
                        ))}
                </Table.Body>
            </Table>

            <Title data={Object.values(data)} />
        </div>
    );
};

export default MiamiRiverMatrix;
